// src/hooks/useUserAvatar.ts
import { useBatchUserAvatars } from './useBatchUserAvatars';

/**
 * Convenience hook for single user avatar
 * Uses batch hook internally for deduplication
 *
 * @param userId - The user ID to fetch avatar for
 * @returns Object with avatarUrl, isLoading, and error state
 *
 * @example
 * ```tsx
 * const { avatarUrl, isLoading } = useUserAvatar(user.id);
 * <Avatar src={avatarUrl || defaultAvatar} />
 * ```
 */
export function useUserAvatar(userId: string | undefined) {
  const { avatarMap, isLoading } = useBatchUserAvatars(userId ? [userId] : []);

  return {
    avatarUrl: userId ? (avatarMap.get(userId) ?? null) : null,
    isLoading,
    error: null, // Batch hook handles errors internally
  };
}

export default useUserAvatar;
